<template>
  <div class="app">
    <v-app-bar clipped-left app dark dense color="bluePcm" class="hidden-sm-and-down">
      <ClientNameAppbar />

     <AppBarGeral/>
    </v-app-bar>
  </div>
</template>

<script>
import ClientNameAppbar from '@/componentes/ClientNameAppbar'
import AppBarGeral from '@/componentes/AppBar'
import { logoutMethod } from '@/utils/commomMethods/logoutMethod'
import { appBarMixins } from '@/mixins/appBarMixins'

export default {
  name: 'AppBar',

  components: { ClientNameAppbar, AppBarGeral },

  mixins: [appBarMixins],

  methods: {
    ...logoutMethod,
  },
}
</script>
<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
